import { MetricListProps } from "@/features/certifications/analytics/types";

import "../styles.css";

const MetricList = ({ rows, className }: MetricListProps) => (
  <dl className={`analytics-metrics flex flex-col gap-200 ${className ?? ""}`}>
    {rows.map((row) => (
      <div
        key={row.key}
        className="analytics-metric flex items-start justify-between gap-200"
      >
        <dt className="body-s-regular">{row.label}</dt>

        <dd className="analytics-value body-s-medium">{row.value}</dd>
      </div>
    ))}
  </dl>
);

export default MetricList;
